import { EventEmitter } from "@stencil/core";

export interface ImageItem {
    url: string;
    relatedType?: string;
    tags?: { [key: string]: string };
    file?: File;
    [key: string]: any;
}

export function resetDragState(
    setDragIndex: (val: number | null) => void,
    setDropTargetIndex: (val: number | null) => void
): void {
    setDragIndex(-1);
    setDropTargetIndex(-1);

    requestAnimationFrame(() => {
        setDragIndex(null);
        setDropTargetIndex(null);
    });
}

export function onDragStart(
    e: DragEvent,
    idx: number,
    setDragIndex: (val: number) => void,
    setIsDragging: (val: boolean) => void
): void {
    setDragIndex(idx);
    setIsDragging(true);
    if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = "move";
    }
}

export function onDragOver(
    e: DragEvent,
    idx: number,
    dropTargetIndex: number,
    setDropTargetIndex: (val: number) => void
): void {
    e.preventDefault();
    if (dropTargetIndex !== idx) {
        setDropTargetIndex(idx);
    }
    if (e.dataTransfer) {
        e.dataTransfer.dropEffect = "move";
    }
}

export function onDrop(
    e: DragEvent,
    idx: number,
    dragIndex: number | null,
    images: ImageItem[],
    emitImagesChanged: EventEmitter<string[]>,
    setImages: (val: ImageItem[]) => void,
    resetFn: () => void
): void {
    e.preventDefault();

    if (dragIndex === null || dragIndex === idx) {
        resetFn();
        return;
    }

    const updatedImages = [...images];
    const [moved] = updatedImages.splice(dragIndex, 1);
    updatedImages.splice(idx, 0, moved);

    setImages(updatedImages);
    emitImagesChanged.emit(updatedImages.map((i) => i.url));
    resetFn();
}

export function onDragEnd(
    setIsDragging: (val: boolean) => void,
    resetFn: () => void
): void {
    setIsDragging(false);
    resetFn();
}

export function onDropZoneDragOver(
    e: DragEvent,
    dropTargetIndex: number,
    imagesLength: number,
    setDropTargetIndex: (val: number) => void
): void {
    e.preventDefault();
    if (dropTargetIndex !== imagesLength) {
        setDropTargetIndex(imagesLength);
    }
    if (e.dataTransfer) {
        e.dataTransfer.dropEffect = "move";
    }
}

export function onDropZoneDrop(
    e: DragEvent,
    imagesLength: number,
    dropHandler: (e: DragEvent, idx: number) => void
): void {
    dropHandler(e, imagesLength);
}

export function onDropZoneDragLeave(
    e: DragEvent,
    setDropTargetIndex: (val: number | null) => void
): void {
    const target = e.currentTarget as HTMLElement;
    const relatedTarget = e.relatedTarget as HTMLElement | null;

    if (!relatedTarget || !target.contains(relatedTarget)) {
        setDropTargetIndex(null);
    }
}
